// Calendar utility functions for adding wedding to calendar

export const WEDDING_EVENT = {
  title: "James & Becca's Wedding",
  description: "Join us for our wedding celebration!",
  location: "Field Place, Worthing, BN13 1NP, United Kingdom",
  startDate: "2026-10-24T12:00:00", // 12:00 PM ceremony start
  endDate: "2026-10-24T23:45:00",   // Ends 11:45 PM same day
};

// Format date for calendar files (YYYYMMDDTHHMMSS)
const formatCalendarDate = (dateString) => {
  return dateString.replace(/[-:]/g, '').replace('.000', '');
};

// Generate Google Calendar URL
export const getGoogleCalendarUrl = () => {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: WEDDING_EVENT.title,
    details: WEDDING_EVENT.description,
    location: WEDDING_EVENT.location,
    dates: `${formatCalendarDate(WEDDING_EVENT.startDate)}/${formatCalendarDate(WEDDING_EVENT.endDate)}`,
  });
  
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

// Generate iCal file content (for Apple Calendar, Outlook, etc.)
export const generateICalFile = () => {
  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//James & Becca//Wedding//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `DTSTART:${formatCalendarDate(WEDDING_EVENT.startDate)}`,
    `DTEND:${formatCalendarDate(WEDDING_EVENT.endDate)}`,
    `SUMMARY:${WEDDING_EVENT.title}`,
    `DESCRIPTION:${WEDDING_EVENT.description}`,
    `LOCATION:${WEDDING_EVENT.location}`,
    'STATUS:CONFIRMED',
    'SEQUENCE:0',
    `UID:wedding-${Date.now()}@jamesandbecca.com`,
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');
  
  return icsContent;
};

// Download iCal file
export const downloadICalFile = () => {
  const icsContent = generateICalFile();
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'james-and-becca-wedding.ics';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

// Generate Outlook.com URL
export const getOutlookUrl = () => {
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: WEDDING_EVENT.title,
    body: WEDDING_EVENT.description,
    location: WEDDING_EVENT.location,
    startdt: WEDDING_EVENT.startDate,
    enddt: WEDDING_EVENT.endDate,
  });
  
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
};

// Generate Yahoo Calendar URL
export const getYahooCalendarUrl = () => {
  const duration = calculateDuration(WEDDING_EVENT.startDate, WEDDING_EVENT.endDate);
  
  const params = new URLSearchParams({
    v: '60',
    title: WEDDING_EVENT.title,
    st: formatCalendarDate(WEDDING_EVENT.startDate),
    dur: duration,
    desc: WEDDING_EVENT.description,
    in_loc: WEDDING_EVENT.location,
  });
  
  return `https://calendar.yahoo.com/?${params.toString()}`;
};

// Calculate duration in format HHMM
const calculateDuration = (start, end) => {
  const startTime = new Date(start);
  const endTime = new Date(end);
  const diffMs = endTime - startTime;
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  return `${String(hours).padStart(2, '0')}${String(minutes).padStart(2, '0')}`;
};
